<div class="samplepo-list table-visible">
  <div class="d-flex align-items-center justify-content-between pb-3">
    <h2 class="mb-0">Line items</h2>
    <div class="ms-3 nav-link p-0 d-flex align-items-center">
      <i class="icon-Add me-1"></i>
      <!-- <a (click)="addNewLine()">Add New</a> -->
      <a class="link" (click)="createNewLine()"
        ><i class="pi pi-plus"></i> Add Line</a
      >
    </div>
    <div
      class="ms-3 nav-link p-0 d-flex align-items-center btncommit"
      [hidden]="isStatusSubmitted()">
      <i class="pi pi-comment me-2" [hidden]="isStatusSubmitted()"></i>
      <a class="link" (click)="printLine()" [hidden]="isStatusSubmitted()"
        >Commit</a
      >
    </div>
    <div class="inline me-auto ms-2">
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div class="samplepo-panel col-auto d-flex justify-content-between">
      <div class="ms-3 nav-link p-0 d-flex align-items-center">
        <a
          [ngClass]="selectedLinesForCheckbox?.length ? 'link' : 'link-disable'"
          (click)="onCopyLines()"
          ><i class="pi pi-copy"></i> Copy</a
        >
      </div>

      <div class="ms-2 nav-link p-0 d-flex align-items-center">
        <a class="icon-Notes icon"></a>
      </div>
      <div class="ms-2 nav-link p-0 d-flex align-items-center">
        <a class="icon-Attachment icon"></a>
      </div>
      <div class="ms-2 nav-link p-0 d-flex align-items-center">
        <a class="link pe-1">Use</a> / <a class="link ps-1">Make</a>
      </div>

      <div
        class="ms-3 nav-link p-0 d-flex align-items-center delete"
        *ngIf="
          purchaseOrderStatus?.toLowerCase() !== 'invoiced' &&
          purchaseOrderStatus?.toLowerCase() !== 'received'
        ">
        <a
          [ngClass]="selectedLinesForCheckbox?.length ? 'link' : 'link-disable'"
          (click)="onDrop()"
          class="delcol"
          ><i class="pi pi-trash"></i> Delete</a
        >
      </div>
      <!-- <div class="ms-3 nav-link p-0 d-flex align-items-center">
        <i class="icon-Copy me-2"></i>
        <a
          [ngClass]="selectedLines?.length ? 'link' : 'link-disable'"
          (click)="onCopy()"
          >Copy</a
        >
      </div> -->
      <div class="ms-3 nav-link p-0 d-flex align-items-center">
        <a class="link" (click)="exportExcel()"
          ><i class="pi pi-cloud-download"></i> Export excel</a
        >
      </div>
      <div class="ms-3 nav-link p-0 d-flex align-items-center">
        <!-- <i class="icon-Add me-1"></i>
        <a class="link" (click)="createNewLine()">Add Line</a> -->
      </div>
    </div>
  </div>
  <p-table
    #dt
    stripedRows
    [value]="purchaseOrderLineList"
    styleClass="p-datatable-customers po-line-items table-hover-bg"
    [rowHover]="true"
    [rows]="25"
    [showCurrentPageReport]="true"
    [scrollable]="true"
    [size]="'small'"
    [resizableColumns]="true"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="false"
    [filterDelay]="0"
    (onRowSelect)="rowSelected($event)"
    [(selection)]="selectedLines"
    dataKey="lineNumberD365"
    editMode="row"
    selectionMode="single"
    styleClass="table-listing">
    <ng-template pTemplate="header">
      <tr class="table-head">
        <th class="fnotes"></th>
        <th>
          <p-tableHeaderCheckbox
            [(ngModel)]="checkAllCheckBoxChecked"
            (change)="selectAllLinesCheckbox($event)"
            class="p-checkbox" />
        </th>
        <!-- <th class="number">#</th> -->
        <th class="number" pSortableColumn="number">#</th>
        <th class="vsku">Vendor SKU</th>
        <th class="dfield">Description</th>
        <th class="category" style="width: 10 rem">Category</th>
        <th class="sip-date">Ship date</th>
        <th class="inh-dates">In-hands date</th>
        <th class="firm">Firm</th>
        <th class="quantity">Quantity</th>
        <th class="namount">Net amount</th>
        <th class="ntotal">NET TOTAL</th>
        <th class="fnotes">Factory Notes</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-samplepoLineItems
      let-editing="editing"
      let-ri="rowIndex">
      <ng-container>
        <tr
          class="p-selectable-row"
          [pEditableRow]="samplepoLineItems"
          [pSelectableRow]="samplepoLineItems"
          (dblclick)="editLine(samplepoLineItems.id)"
          [style]="styleObject(samplepoLineItems.isHighlighted)">
          <td style="text-align: center">
            <button
              *ngIf="!editing"
              pButton
              pRipple
              type="button"
              pInitEditableRow
              icon="pi pi-pencil"
              (click)="onRowEditInit(samplepoLineItems)"
              class="p-button-rounded p-button-text"></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pSaveEditableRow
              icon="pi pi-check"
              (click)="onRowEditSave(samplepoLineItems)"
              class="p-button-rounded p-button-text p-button-success p-mr-2 selectable-color"></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pCancelEditableRow
              icon="pi pi-times"
              (click)="onRowEditCancel(samplepoLineItems)"
              class="p-button-rounded p-button-text p-button-danger"></button>
          </td>
          <td
            [ngClass]="{
              checkboxhighlightfontcolor:
                samplepoLineItems.isHighlighted === true,
            }">
            <input
              type="checkbox"
              [checked]="samplepoLineItems?.isHighlighted"
              (change)="lineItemsCheckboxChanged(samplepoLineItems, $event)"
              class="p-checkbox" />
            <!-- <p-tableCheckbox
              [value]="samplepoLineItems"
              [pEditableRow]="samplepoLineItems"
              [pSelectableRow]="samplepoLineItems"
            ></p-tableCheckbox> -->
          </td>
          <td class="number">
            <span
              class="link line-number"
              (click)="onLineRedirect()"
              [ngClass]="{
                checkboxhighlightfontcolor:
                  samplepoLineItems.isHighlighted === true,
              }">
              {{ samplepoLineItems.lineNumberD365 }}
            </span>
          </td>
          <td
            class="vsku"
            [ngClass]="{
              checkboxhighlightfontcolor:
                samplepoLineItems.isHighlighted === true,
            }">
            <!-- {{ samplepoLineItems.value.externalItemNumberD365 }} -->
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  [(ngModel)]="samplepoLineItems.externalItemNumberD365" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ samplepoLineItems.externalItemNumberD365 }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td
            class="dfield"
            [ngClass]="{
              checkboxhighlightfontcolor:
                samplepoLineItems.isHighlighted === true,
            }">
            <!-- {{ samplepoLineItems.value.lineDescriptionD365 }} -->
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  [(ngModel)]="samplepoLineItems.lineDescriptionD365" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ samplepoLineItems.lineDescriptionD365 }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td
            class="category"
            [ngClass]="{
              checkboxhighlightfontcolor:
                samplepoLineItems.isHighlighted === true,
            }">
            <!-- {{ samplepoLineItems.value.itemNumberD365 }} -->
            <p-cellEditor>
              <ng-template pTemplate="input">
                <!-- <input
                  pInputText
                  type="text"
                  [(ngModel)]="samplepoLineItems.itemNumberD365"
                  required
                /> -->
                <p-select
                  id="currency"
                  [(ngModel)]="samplepoLineItems.itemNumberD365"
                  [options]="releasedProductsStrList"
                  [appendTo]="'body'">
                </p-select>
              </ng-template>
              <ng-template pTemplate="output">
                {{ samplepoLineItems.itemNumberD365 }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td
            class="sip-date"
            [ngClass]="{
              checkboxhighlightfontcolor:
                samplepoLineItems.isHighlighted === true,
            }">
            <!-- {{
              samplepoLineItems.value.requestedShippingDateD365
                | date: 'MM-dd-yyyy'
            }} -->
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-datepicker
                  jniAutoCompleteBlocker
                  #sdp
                  inputId="basic"
                  class="date-input"
                  [(ngModel)]="samplepoLineItems.requestedShippingDateD365"
                  [showOtherMonths]="true"
                  [selectOtherMonths]="true"
                  (onInput)="handleKeyDown($event, sdp)"
                  (onShow)="setShipMinDate(samplepoLineItems)"
                  [minDate]="shipMindate"
                  showOnFocus="false"
                  iconDisplay="input"
                  showIcon="true"
                  [dateFormat]="'mm/dd/yy'"
                  [appendTo]="'body'"></p-datepicker>
              </ng-template>
              <ng-template pTemplate="output">
                <span
                  *ngIf="
                    samplepoLineItems.requestedShippingDateD365
                      | hidedynamicsdate
                  ">
                  {{
                    samplepoLineItems.requestedShippingDateD365
                      | date: "MM/dd/yyyy"
                  }}</span
                >
              </ng-template>
            </p-cellEditor>
          </td>
          <td
            class="inh-dates"
            [ngClass]="{
              checkboxhighlightfontcolor:
                samplepoLineItems.isHighlighted === true,
            }">
            <!-- {{
              samplepoLineItems.value.requestedDeliveryDateD365
                | date: 'MM-dd-yyyy'
            }} -->
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-datepicker
                  jniAutoCompleteBlocker
                  #ddp
                  inputId="basic"
                  class="date-input"
                  [(ngModel)]="samplepoLineItems.requestedDeliveryDateD365"
                  [showOtherMonths]="true"
                  [selectOtherMonths]="true"
                  (onInput)="handleKeyDown($event, ddp)"
                  (onShow)="setInHandMinDate(samplepoLineItems)"
                  [minDate]="inHandMindate"
                  showOnFocus="false"
                  showIcon="true"
                  iconDisplay="input"
                  [dateFormat]="'mm/dd/yy'"
                  [appendTo]="'body'"></p-datepicker>
              </ng-template>
              <ng-template pTemplate="output">
                <span
                  *ngIf="
                    samplepoLineItems.requestedDeliveryDateD365
                      | hidedynamicsdate
                  ">
                  {{
                    samplepoLineItems.requestedDeliveryDateD365
                      | date: "MM/dd/yyyy"
                  }}
                </span>
              </ng-template>
            </p-cellEditor>
          </td>
          <td
            class="firm"
            [ngClass]="{
              checkboxhighlightfontcolor:
                samplepoLineItems.isHighlighted === true,
            }">
            <i
              class="pi pi-star"
              *ngIf="samplepoLineItems.rsmFirmD365.toLowerCase() === 'no'"></i>
            <i
              class="pi pi-star-fill"
              *ngIf="samplepoLineItems.rsmFirmD365.toLowerCase() === 'yes'"></i>
          </td>
          <td
            class="quantity"
            [ngClass]="{
              checkboxhighlightfontcolor:
                samplepoLineItems.isHighlighted === true,
            }">
            <!-- {{ samplepoLineItems.value.orderedPurchaseQuantityD365 }} -->
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  [(ngModel)]="samplepoLineItems.orderedPurchaseQuantityD365"
                  (focusout)="
                    calculateQuantity(
                      samplepoLineItems.orderedPurchaseQuantityD365,
                      samplepoLineItems
                    )
                  " />
              </ng-template>
              <ng-template pTemplate="output">
                {{ samplepoLineItems.orderedPurchaseQuantityD365 }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td
            class="namount"
            [ngClass]="{
              checkboxhighlightfontcolor:
                samplepoLineItems.isHighlighted === true,
            }">
            <!-- {{
              samplepoLineItems.value.purchasePriceD365
                | currency: purchaseOrderHeader?.currencyCodeD365
            }} -->
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  [(ngModel)]="samplepoLineItems.purchasePriceD365"
                  (focusout)="
                    onNetConversion(
                      samplepoLineItems.purchasePriceD365,
                      samplepoLineItems
                    )
                  " />
              </ng-template>
              <ng-template pTemplate="output">
                {{
                  samplepoLineItems.purchasePriceD365
                    | currency
                      : getCurrencyConvertionCode(
                          purchaseOrderHeader?.currencyCodeD365 || ""
                        )
                      : "symbol"
                      : "0.4-4"
                }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td
            class="ntotal"
            [ngClass]="{
              checkboxhighlightfontcolor:
                samplepoLineItems.isHighlighted === true,
            }">
            {{
              samplepoLineItems.lineAmountD365
                | currency
                  : getCurrencyConvertionCode(
                      purchaseOrderHeader?.currencyCodeD365 || ""
                    )
                  : "symbol"
                  : "0.2-2"
            }}
            <!-- <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="text"
                  [(ngModel)]="samplepoLineItems.lineAmountD365"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ samplepoLineItems.lineAmountD365 }}
              </ng-template>
            </p-cellEditor> -->
          </td>
          <td
            class="fnotes"
            [ngClass]="{
              checkboxhighlightfontcolor:
                samplepoLineItems.isHighlighted === true,
            }">
            <!-- {{ samplepoLineItems.value.factoryNotes }} -->
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  [(ngModel)]="samplepoLineItems.factoryNotesD365" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ samplepoLineItems.factoryNotesD365 }}
              </ng-template>
            </p-cellEditor>
          </td>
        </tr>
      </ng-container>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="18">No line found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
